import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import IconButton from "@material-ui/core/IconButton";
import { ClickAwayListener } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    border: " rgba(17, 70, 93, 0.2) 0.5px solid",
    backgroundColor: theme.palette.background.paper,
  },
  Count: {
    display: "inline",
  },
  Button: {
    padding: 0,
  },
}));

export default function GuestNumber(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(false);

  const [countAdult, setCountAdult] = useState(0);

  const [countChild, setcountChild] = useState(0);

  const PlusChild = () => {
    setcountChild(countChild + 1);
  };

  const MinorChild = () => {
    setcountChild(countChild - 1);
  };

  const PlusAdult = () => {
    setCountAdult(countAdult + 1);
  };

  const MinorAdult = () => {
    setCountAdult(countAdult - 1);
  };

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "transitions-popper" : undefined;

  const handleClick2 = (event) => {
    setAnchorEl("");
  };

  return (
    <ClickAwayListener onClickAway={handleClick2}>
      <>
        <Button
          style={{ padding: "5px 0 0 0" }}
          variant="text"
          onClick={handleClick}
        >
          <TextField
            id="filled-textarea"
            placeholder="0"
            multiline
            label="Số khách"
            disabled="true"
            value={countAdult + countChild}
            InputProps={{ disableUnderline: true }}
          />
        </Button>

        <Popper
          style={{ margin: "20px", borderRadius: "50%" }}
          id={id}
          open={open}
          anchorEl={anchorEl}
          transition
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper>
                <div className={classes.paper}>
                  <Grid container direction="row">
                    <Grid container item direction="column" xs={7}>
                      <Grid item>
                        <Typography className={classes.Count}>
                          Người lớn
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.Count}>
                          Từ 13 tuổi trở lên
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      item
                      xs={5}
                      justify="center"
                      alignItems="center"
                    >
                      <IconButton
                        className={classes.Button}
                        disabled={countAdult < 1 ? true : false}
                      >
                        <RemoveCircleIcon
                          onClick={MinorAdult}
                          style={{ fontSize: "35" }}
                        />
                      </IconButton>

                      <Typography
                        style={{ fontSize: "25px" }}
                        className={classes.Count}
                      >
                        {countAdult}
                      </Typography>
                      <IconButton className={classes.Button}>
                        <AddCircleIcon
                          style={{ fontSize: "35" }}
                          onClick={PlusAdult}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                </div>
                <div className={classes.paper}>
                  <Grid container direction="row">
                    <Grid container item direction="column" xs={7}>
                      <Grid item>
                        <Typography className={classes.countChild}>
                          Trẻ em
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.countChild}>
                          Dưới 13 tuổi
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      item
                      xs={5}
                      justify="center"
                      alignItems="center"
                    >
                      <IconButton
                        className={classes.Button}
                        disabled={countChild < 1 ? true : false}
                      >
                        <RemoveCircleIcon
                          onClick={MinorChild}
                          style={{ fontSize: "35" }}
                        />
                      </IconButton>

                      <Typography
                        style={{ fontSize: "25px" }}
                        className={classes.countChild}
                      >
                        {countChild}
                      </Typography>
                      <IconButton className={classes.Button}>
                        <AddCircleIcon
                          style={{ fontSize: "35" }}
                          onClick={PlusChild}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                </div>
              </Paper>
            </Fade>
          )}
        </Popper>
      </>
    </ClickAwayListener>
  );
}
